import { IMapLayer } from 'app/system/mobile-models/profile-models';
import { OSM, TileWMS, XYZ } from 'ol/source';
import TileSource from 'ol/source/Tile';
import { createXYZ } from 'ol/tilegrid';
import { get as getProjection } from 'ol/proj';

export function createBaseLayerSource(layer: IMapLayer): TileSource {
  const provider = (layer.provider ?? '').toLowerCase();
  const url = layer.url ?? '';

  switch (provider) {
    case 'osm':
      return new OSM({ crossOrigin: null, ...(url ? { url } : {}) });

    case 'google':
      return new XYZ({
        url: `https://mt{0-3}.google.com/vt/lyrs=${url === 'HYBRID' ? 'y' : 'm'}&x={x}&y={y}&z={z}`,
      });

    case 'yandex':
      return new XYZ({
        url: url.toLowerCase() === 'sat'
          ? 'https://sat02.maps.yandex.net/tiles?l=sat&x={x}&y={y}&z={z}'
          : `https://core-renderer-tiles.maps.yandex.net/tiles?l=${url.toLowerCase()}&x={x}&y={y}&z={z}`,
        projection: 'EPSG:3395',
      });

    case 'wms': {
      const projection = getProjection('EPSG:3857');
      const tileGrid = createXYZ({ extent: projection.getExtent(), tileSize: 512 });
      return new TileWMS({
        url,
        params: { srs: 'EPSG:3857' },
        serverType: 'mapserver',
        tileGrid,
      });
    }

    default:
      return new OSM({ crossOrigin: null });
  }
}
